

export const commonRoutes = {
  get LOGIN() {
    return 'login';
  },
  get DRUGS() {
    return 'drugs';
  },
  get FORGOT_PASSWORD() {
    return 'forgot-password';
  },
  get CREATE_PASSWORD() {
    return 'create-password';
  },
  get RESET_PASSWORD() {
    return 'reset-password';
  },
  get DASHBOARD() {
    return 'dashboard';
  },
  get PROFILE() {
    return 'profile';
  },
  get VIEW_DRUG() {
    return `${this.DRUGS}/edit`;
  },
  get EDIT_UN_REGISTERED_DRUG() {
    return `${this.DRUGS}/edit-un-registered`;
  },
  get UPDATE_PROFILE() {
    return 'update-profile';
  },
  get SUBSCRIBED_LIST() {
    return 'subscribed-list';
  },
  get UNREGISTERED_DRUGS_REQUESTS() {
    return 'unregistered-drugs-requests';
  },
  get ADD_UNREGISTERED_DRUGS_REQUESTS() {
    return `${this.UNREGISTERED_DRUGS_REQUESTS}/add`;
  },
  get EDIT_UNREGISTERED_DRUGS_REQUESTS() {
    return `${this.UNREGISTERED_DRUGS_REQUESTS}/edit`;
  },
  get ADD_DRUG() {
    return `${this.DRUGS}/add`;
  },
  get EDIT_DRUG() {
    return `${this.DRUGS}/edit`;
  }

};


